import { Button, Icon } from "Components";

export interface StepFooterProps {
    onBack: () => void | null;
    onNext: () => void;
    nextBtnText?: string;
    nextBtnDisabled: boolean,
    isLoading?: boolean
}

export default function StepFooter({ onBack, onNext, nextBtnText = "Next", nextBtnDisabled, isLoading = false }: StepFooterProps) {
    return <div className="step-footer">
        {onBack && <Button ghost shape="round" type="primary" onClick={onBack}>
            <Icon type="previousPagination" />
            Back
        </Button>}
        <Button shape="round" type="primary" disabled={nextBtnDisabled} className={`next-btn ${nextBtnDisabled ? 'cta-disabled' : ''}`} loading={isLoading} onClick={onNext}>
            {nextBtnText}
            {nextBtnText === "Next" && <Icon type="campaignPaginationNextBlur" />}
        </Button>
    </div>
}